import AutoAbstractField from "./AutoAbstractField.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import G from "../../libs/Glob.mjs";

const AutoItemInfoField = class extends AutoAbstractField {
	renderField() {
		const le = this.props.formHelper.getValue('formControl_lastEdit');
		return (
			<div>
				<h1>
					{this.props.formHelper.getValue('name')}
				</h1>
				{le?.editorLogin && (
					<table>
						<tbody>
						<tr>
							<td rowSpan={3} style={{verticalAlign: "top"}}>
								<h5 className={"mt-1"}>
									<TextLabel value={"Last edit"}/>
								</h5>
							</td>
							<td rowSpan={3} />
							<td className={"text-end text-secondary"}>
								<TextLabel value={"Login"}/>:
							</td>
							<td rowSpan={3}/>
							<td>
								{le.editorLogin}
							</td>
						</tr>
						<tr>
							<td className={"text-end text-secondary"}>
								<TextLabel value={"Name"}/>:
							</td>
							<td>
								{le.editorName}
							</td>
						</tr>
						<tr>
							<td className={"text-end text-secondary"}>
								<TextLabel value={"When"}/>:
							</td>
							<td>
								{new Date(le.time).toLocaleString(G.getLanguageLong())}
							</td>
						</tr>
						</tbody>
					</table>
				)}
				<hr style={{margin: "8px 0", padding:"0"}}/>
			</div>
		)
	}
}

export default AutoItemInfoField;